<script setup>
	import { ref, computed, watch } from 'vue';
	import { useMapStoreData, useScreensaverStore } from '@/stores/index';
	import { useI18n } from 'vue-i18n';
	import chevronDown from '@/assets/chevron-down.svg';
	// import enFlag from '@/assets/languages/en-flag.svg';
	// import slFlag from '@/assets/languages/sl-flag.svg';
	// import deFlag from '@/assets/languages/de-flag.svg';
	// import hrFlag from '@/assets/languages/hr-flag.svg';
	// import itFlag from '@/assets/languages/it-flag.svg';

	const { locale } = useI18n();
	// const flags = {
	// 	en: enFlag,
	// 	sl: slFlag,
	// 	de: deFlag,
	// 	hr: hrFlag,
	// 	it: itFlag,
	// };

	const mapStore = useMapStoreData();

	const allLanguages = ref(mapStore.allLanguages);
	const isOpen = ref(false);
	const screensaverStore = useScreensaverStore();
	const props = defineProps(['uniqueClass']);
	const bottom = computed(() => {
		if (window.innerWidth > 600) {
			if (mapStore.allLanguages.length == 2) {
				return '-4.3vw';
			} else {
				let temp = mapStore.allLanguages.length * -4.1;
				return temp + 'vw';
			}
		} else {
			if (mapStore.allLanguages.length == 2) {
				return '-8.3vw';
			} else {
				let temp = mapStore.allLanguages.length * -7;
				return temp + 'vw';
			}
		}
	});
	const toggleDropdown = () => {
		isOpen.value = !isOpen.value;
	};

	const selectOption = (option) => {
		selectedLanguage.value = option;
		mapStore.changeLanguage(option);
		locale.value = option;
		screensaverStore.stopScreensaverTimer();
		toggleDropdown();
	};

	const selectedLanguage = computed(() => mapStore.currentLanguage);
	watch(
		() => screensaverStore.showSreensaver,
		(newValue) => {
			if (newValue) {
				//selectOption(useMapStoreData().allLanguages[0]);
				selectedLanguage.value = useMapStoreData().allLanguages[0];
				mapStore.changeLanguage(useMapStoreData().allLanguages[0]);
				locale.value = useMapStoreData().allLanguages[0];
			}
		}
	);
</script>

<template>
	<div class="languageChanger" v-if="allLanguages.length != 1" :class="[props.uniqueClass, { isOpen: isOpen }]">
		<div class="option" @click="toggleDropdown">
			<span>{{ selectedLanguage ? selectedLanguage : 'Select an option' }}</span>
			<div class="line"></div>
			<img :src="chevronDown" alt="" class="chevron-down" />
		</div>
		<ul class="list" :style="{ bottom: bottom }" v-show="isOpen">
			<li
				class="option"
				v-for="option in allLanguages"
				v-show="selectedLanguage != option"
				:key="option"
				@click="selectOption(option)"
			>
				<span>{{ option }}</span>
			</li>
		</ul>
	</div>
</template>

<style scoped lang="scss">
	@import '../assets/style/mixins.scss';
	@import '../assets/style/components/_languageChanger.scss';

	.chevron-down {
		transition: transform 0.3s ease;
	}

	.languageChanger.isOpen .chevron-down {
		transform: rotate(180deg);
	}
</style>
